import React from 'react';

import ProjectDesktopImage from '../../../../components/project/project-desktop-image';
import ProjectLogoWork from '../../../../components/project/project-logo-work';
import ProjectSliderWeichert from '../../../../components/project/project-slider-weichert/project-slider-animation';
import ProjectVideoLoop from '../../../../components/project/project-video-loop';
import ProjectVideoAds from '../../../../components/project/project-video-ads';
import ProjectBrandedMaterials from '../../../../components/project/project-branded-materials';
import ProjectInteriorPages from '../../../../components/project/project-interior-pages';
import ProjectAdStills from '../../../../components/project/project-ad-stills';
import ProjectMobileStagger from '../../../../components/project/project-mobile-stagger';
import ProjectFullBanner from '../../../../components/project/project-full-banner';

const WeichertCaseStudy = ({ slug, acf }) => {
  return (
    <React.Fragment>
      <ProjectDesktopImage
        desktopImage={acf.desktop_design}
        backgroundColor={acf.desktop_image_background}
        blurb={acf.desktop_design_blurb}
        wrapperPadding={'0'}
      />
      <ProjectMobileStagger
        mobileImages={acf.mobile}
        blurb={acf.mobile_blurb}
        wrapperPadding={'5vw 0 5vw 0'}
      />
      <ProjectSliderWeichert
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={[
          'calc(5vw - 14px) 10vw 5vw 10vw',
          'calc(10vw - 14px) 0 5vw 0',
        ]}
      />
      <ProjectBrandedMaterials
        image={acf.branded_materials_image}
        blurb={acf.branded_materials_blurb}
        wrapperPadding={'5vw 0 5vw 0'}
        hideBlurb={true}
      />
      <ProjectFullBanner
        image={acf.full_banner_image}
        blurb={acf.full_banner_blurb}
        wrapperPadding={'0 0 5vw 0'}
      />
      <ProjectVideoLoop
        videoId={acf.video_loop_id}
        muted={'true'}
        background={'true'}
        blurb={acf.video_loop_blurb}
        wrapperPadding={'0 0 10vw 0'}
        autoplay={true}
      />
    </React.Fragment>
  );
};

export default WeichertCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/weichert-franchising/index.js